import React, { useEffect, useState } from 'react';
import { Modal, Table } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Loading from '~/Components/Loading';
import * as api from '~/Services/Service';
import { formatarData } from '../helpers/formatar';

const ModalSituacaoPagFor = ({ show, sequencia, onClose }) => {
  const [dados, setDados] = useState([]);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    let ativo = true;
    if (!show || !sequencia) return () => {
      ativo = false;
    };
    setCarregando(true);
    api
      .obterSituacaoPagForAutorizaDespesa(sequencia)
      .then((res) => {
        if (!ativo) return;
        setDados(res || []);
      })
      .catch((err) => {
        if (!ativo) return;
        const msg = err && err.message ? err.message : 'Erro ao buscar situação PagFor';
        toast.error(msg);
      })
      .finally(() => {
        if (!ativo) return;
        setCarregando(false);
      });
    return () => {
      ativo = false;
    };
  }, [show, sequencia]);

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Situação Pagamento Fornecedor</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {carregando ? (
          <Loading />
        ) : (
          <Table striped bordered hover responsive size="sm">
            <thead>
              <tr>
                <th>Banco</th>
                <th>Agência</th>
                <th>Conta</th>
                <th>Data</th>
                <th>Situação</th>
              </tr>
            </thead>
            <tbody>
              {dados.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center">
                    Nenhum registro encontrado
                  </td>
                </tr>
              ) : (
                dados.map((item) => (
                  <tr key={`${item.banco || ''}-${item.agencia || ''}-${item.conta || ''}-${item.data || ''}`}>
                    <td>{item.banco}</td>
                    <td>{item.agencia}</td>
                    <td>{item.conta}</td>
                    <td>{formatarData(item.data)}</td>
                    <td>{item.situacao || item.status}</td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ModalSituacaoPagFor;
